// 영업활동계획(신규) — 새 테이블(TBL_SLOP_ACTV_PLAN_MST/AMT_DTL/ACT_DTL) 전용 API 모듈.
// 기존 modules/mypage.js 의 bsnPln* 함수는 전혀 건드리지 않는다.
import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  list(parameters={}) {
    return core.call({
      url: '/api/v1/bsnplan2/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  existInfo(parameters={}) {
    return core.call({
      url: '/api/v1/bsnplan2/existInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  form(parameters={}) {
    return core.call({
      url: '/api/v1/bsnplan2/form',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  save(parameters={}) {
    return core.call({
      url: '/api/v1/bsnplan2/save',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }
    });
  },
  memberList(parameters={}) {
    return core.call({
      url: '/api/v1/bsnplan2/memberList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  reqPlan(parameters={}) {
    return core.call({
      url: '/api/v1/bsnplan2/reqPlan',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }
    });
  }
}
